import { ProductionFigureThemeSizeConfig } from './types';

const large: ProductionFigureThemeSizeConfig = {
  productionFigure: {},
};

export default large;
